var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWind = function SvgIconWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.441 5.14a1.25 1.25 0 0 0-1.124.402 1 1 0 1 1-1.49-1.334 3.25 3.25 0 1 1 2.424 5.417H2.25a1 1 0 0 1 0-2h9a1.25 1.25 0 0 0 .191-2.485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.691 8.89a1.25 1.25 0 0 0-1.124.402 1 1 0 1 1-1.49-1.334 3.25 3.25 0 1 1 2.423 5.417H3a1 1 0 1 1 0-2h16.5m0 0a1.252 1.252 0 0 0 1.14-1.76 1.25 1.25 0 0 0-.949-.725",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 16.125a1 1 0 0 1 1-1h10.5a3.253 3.253 0 0 1 3.24 3 3.249 3.249 0 0 1-5.663 2.417 1 1 0 0 1 1.49-1.334 1.25 1.25 0 1 0 .932-2.083H3.75a1 1 0 0 1-1-1"
  }))));
};
export default SvgIconWind;